import React, { useState, useEffect } from "react";
import {
    TextInput,
     RadioInput,
    FileInput,
    SelectInput, EmailInput,
    PhoneInput, CheckBoxInput,
    AutoComplete,
    Pincode,
    AvailableSlots,
    FileInputV2
} from "../reusable/index";
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
    genderOptions, specialtyOptions,
    addressProofOptions,
    consultTypeOptions,
    languageOptions,
    termsAndConditionsOptions,
    countryOptions,
    stateOptions,
    weekOptions,
    validateName,
    errorMessages,
    validateMobile,
    validatePan,
    validateEmail
} from '../utils/helper';
import { Typography, Checkbox, FormControlLabel, Button } from '@material-ui/core';
import { useHistory, useParams } from "react-router-dom";

import users from '../services/user';
import dashboard from "../services/dashboard";
import { AvailableSlotsPhysical } from "../reusable/AvailableSlotsPhysical";

const useStyles = makeStyles((theme) => ({
    registerContainer: {
        fontFamily: "'Roboto', sans- serif",
        '& h2': {
            fontSize: 24,
            fontWeight: '700',
            color: '#007c9d',
        }
    },
    registerForm: {
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        }
    },
    registerContent: {
        width: '100%',

    },
    submitBtn: {
        padding: '10px 20px',
        background: '#007c9d',
        color: '#fff',
        fontSize: 14,
        fontWeight: '700',
        textTransform: 'uppercase',
        boxShadow: 'none',
        border: 'none',
        borderRadius: 20,
        width: 180,
        margin: '30px auto 0'
    },
    apr: {
        [theme.breakpoints.down('xs')]: {
            '& input': {
                margin: '15px 0 0'
            }
        }
    },
    tncContainer: {
        padding: '10px 0',
        textAlign: 'left',
        '& h4': {
            fontSize: 16,
            color: '#949494'
        },
        '& p': {
            fontSize: 14
        }
    },
    tncList: {
        margin: '10px 0',
        padding: '0 0 0 20px',
        '& li': {
            padding: '5px 0',
            fontSize: 12,
        }
    }
}));

const Register = () => {
    const classes = useStyles();
    const history = useHistory();
    const [value, setValue] = useState({})
    const [consultType, setConsultType] = useState()
    const [checked, setChecked] = React.useState(false);
    const [count, setCount] = useState(0)
    const [defaultValue, setDefaultValue]= useState({})
    const [isEditLoading, setIsEditLoading] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const [error, setError] = useState({
        email: '',
        firstName: '',
        middleName: '',
        lastName: '',
        displayName: '',
        gender: '',
        phone: '',
        alternatePhone: '',
        panNumber: '',
        languages: '',
        profilepic: '',
        pancard: '',
        locationName: '',
        address: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        addressProof: '',
        addressProofFile: '',
        // representativeName: '',
        education: '',
        experience: '',
        specialty: '',
        mciNumber: '',
        certifications: '',
        registrationCertificate: '',
        degreeCertificates: '',
        availableSlots: '',
        clinic: '',
        consultType: '',
        onlinefees: '',
        physicalfees: '',
        nameAsPerBank: '',
        accountNumber: '',
        ifscCode: '',
        secretaryName: '',
        secretaryNumber: '',
        bankBranch: '',
        alternatePhoneTwo: '',
       btech_education_proof:'',
       phd_education_proof:'',
       diploma_education_proof:'', 
       dnb_certificate:'',
       speciality_certificate:'',
       fellowship_certificate:'', 
       membership:'',
       conditions_procedure:'',
       services_offered:'',
       publication_link:'',
       adhar_backside:'',
       cancel_check:'',
    })
    const {id: salesPersonId} = useParams()

    const {doctorId} = useParams() || {}

    const [salesData, setSalesData] = useState()

    useEffect(()=> {
        dashboard.getSalesPersonById(salesPersonId).then(({data})=> {
            if (!data.id) {
                history.push('/404')
            } else {
                setSalesData(data)
            }
        }).catch((err)=> {
            console.error(err)
            history.push('/404')
            throw err
        })
    }, [])

    const fetchDoctorData = async () => {
        setIsEditLoading(true);
        await dashboard.edit(salesPersonId,doctorId).then(({data})=> {
            setDefaultValue(data)
            setValue(data)
    }).catch((err)=> {
        console.error(err)
        throw err
    }).finally(()=>{
        setIsEditLoading(false)
    })
    }

    useEffect( ()=> {
        if (doctorId) {
        fetchDoctorData()
        }
    }, [])

    const handleChange = (event) => {
        value[event.target.name] = event.target.value
        setValue(value)
        console.log(value)
    }

    const handleTerms = (event) => {
        setChecked(event.target.checked);
    }

    const handleError = (name) => {
        if (!value[name]) {
            error[name] = 'This is Required field'
            setError({ ...error, error })
        } else {
            error[name] = ''
            setError({ ...error, error })
        }
    }

    const sortByAlphabetical = (array) => {
       return array.sort(function(a, b){
            if(a.key < b.key) { return -1; }
            if(a.key > b.key) { return 1; }
            return 0;
        })
    }

    const validateForm = (value) => {
        if (!value['slots'] || value['slots'].length < 1) {
            console.log('You have to Fill Consultation Availability')
            alert('You have to Fill Consultation Availability')
            return
        }
        else if (!value.gender || value.gender.length < 1) {
            console.log('You have to Select Gender')
            alert('You have to Select Gender')
            return
        }
        else if (!value.languages || value.languages.length < 1) {
            console.log('You have to Select Languages')
            alert('You have to Select Languages')
            return
        }
        else if (!value.weekdays || value.weekdays.length < 1) {
            console.log('You have to Select Weekday')
            alert('You have to Select Weekday')
            return
        }
        else if (!value.email || value.email.length < 1) {
            console.log('You have to fill Email Address')
            alert('You have to fill Email Address')
            return
        }
        else if (!value.firstName || value.firstName.length < 1) {
            console.log('You have to fill First Name')
            alert('You have to fill First Name')
            return
        }
        else if (!value.middleName || value.middleName.length < 1) {
            console.log('You have to fill Middle Name')
            alert('You have to fill Middle Name')
            return
        }
        else if (!value.lastName || value.lastName.length < 1) {
            console.log('You have to fill Last Name')
            alert('You have to fill Last Name')
            return
        }
        else if (!value.displayName || value.displayName.length < 1) {
            console.log('You have to fill Display Name')
            alert('You have to fill Display Name')
            return
        }
        else if (!value.phone || value.phone.length < 1) {
            console.log('You have to fill Mobile No')
            alert('You have to fill Mobile No')
            return
        }
        // else if (!value.alternatePhone || value.alternatePhone.length < 1) {
        //     console.log('You have to fill Alternate Phone')
        //     alert('You have to fill Alternate Phone')
        //     return
        // }
        else if (!value.profilepic || value.profilepic.length < 1) {
            console.log('You have to upload Profile Picture')
            alert('You have to upload Profile Picture')
            return
        }
        else if (!value.panNumber || value.panNumber.length < 1) {
            console.log('You have to fill PAN Number')
            alert('You have to fill PAN Number')
            return
        }
        else if (!value.pancard || value.pancard.length < 1) {
            console.log('You have to upload PAN CARD')
            alert('You have to upload PAN CARD')
            return
        }
        else if (!value.clinic || value.clinic.length < 1) {
            console.log('You have to fill Name of the Clinic / Hospital')
            alert('You have to fill Name of the Clinic / Hospital')
            return
        }
        else if (!value.locationName || value.locationName.length < 1) {
            console.log('You have to fill Clinic/Hospital Street Name')
            alert('You have to fill Clinic/Hospital Street Name')
            return
        }
        else if (!value.address || value.address.length < 1) {
            console.log('You have to fill Clinic/Hospital Address')
            alert('You have to fill Clinic/Hospital Address')
            return
        }
        else if (!value.pincode || value.pincode.length < 1) {
            console.log('You have to fill Pincode')
            alert('You have to fill Pincode')
            return
        }
        else if (!value.city || value.city.length < 1) {
            console.log('You have to fill City')
            alert('You have to fill City')
            return
        }
        else if (!value.state || value.state.length < 1) {
            console.log('You have to fill State')
            alert('You have to fill State')
            return
        }
        else if (!value.addressProof || value.addressProof.length < 1) {
            console.log('You have to Select Address Proof')
            alert('You have to Select Address Proof')
            return
        }
        else if (!value.addressProofFile || value.addressProofFile.length < 1) {
            console.log('You have to upload Address Proof File')
            alert('You have to upload Address Proof File')
            return
        }
        else if (!value.education || value.education.length < 1) {
            console.log('You have to fill Education')
            alert('You have to fill Education')
            return
        }
        else if (!value.experience || value.experience.length < 1) {
            console.log('You have to fill Experience')
            alert('You have to fill Experience')
            return
        }
        else if (!value.specialty || value.specialty.length < 1) {
            console.log('You have to select Specialty')
            alert('You have to select Specialty')
            return
        }
        else if (!value.mciNumber || value.mciNumber.length < 1) {
            console.log('You have to fill MCI Number')
            alert('You have to fill MCI Number')
            return
        }
        else if (!value.registrationCertificate || value.registrationCertificate.length < 1) {
            console.log('You have to upload Registration Certificate')
            alert('You have to upload Registration Certificate')
            return
        }
        else if (!value.consultType || value.consultType.length < 1) {
            console.log('You have to fill Consult Type')
            alert('You have to fill Consult Type')
            return
        }
        else if (value.consultType === consultTypeOptions[0].value && !value.onlinefees.toString()) {
            console.log('You have to fill Online Consultation Fees')
            alert('You have to fill Online Consultation Fees')
            return
        }
        else if (value.consultType === consultTypeOptions[1].value && !value.physicalfees.toString()) {
            console.log('You have to fill Physical Consultation Fees')
            alert('You have to fill Physical Consultation Fees')
            return
        }
        else if (value.consultType === consultTypeOptions[2].value && !value.onlinefees.toString()) {
            console.log('You have to fill Online Consultation Fees')
            alert('You have to fill Online Consultation Fees')
            return
        }
        else if (value.consultType === consultTypeOptions[2].value && !value.physicalfees.toString()) {
            console.log('You have to fill Physical Consultation Fees')
            alert('You have to fill Physical Consultation Fees')
            return
        }
        
        else if (!value.nameAsPerBank || value.nameAsPerBank.length < 1) {
            console.log('You have to fill Name As Per Bank')
            alert('You have to fill Name As Per Bank')
            return
        }
        else if (!value.bankBranch || value.bankBranch.length < 1) {
            console.log('You have to fill Bank Branch Name')
            alert('You have to fill Bank Branch Name')
            return
        }
        else if (!value.accountNumber || value.accountNumber.length < 1) {
            console.log('You have to fill Account Number')
            alert('You have to fill Account Number')
            return
        }
        else if (!value.ifscCode || value.ifscCode.length < 1) {
            console.log('You have to fill IFSC Code')
            alert('You have to fill IFSC Code')
            return
        } 
        else if (!value.email || !validateEmail(value.email)) {
            console.log('Invalid Email Format Please check')
            alert('Invalid Email Format Please check')
            return
        }
        else if (!value.phone || !validateMobile(value.phone)) {
            console.log('Invalid Phone Format Please check')
            alert('Invalid Phone Format Please check')
            return
        }
        else if (!value.panNumber || !validatePan(value.panNumber)) {
            console.log('Invalid PAN Format Please check')
            alert('Invalid PAN Format Please check')
            return
        }
        else if (!value.firstName || !validateName(value.firstName)) {
            console.log('Invalid First Name Format')
            alert('Invalid First Name Format')
            return
        }
        else if (!value.lastName || !validateName(value.lastName)) {
            console.log('Invalid Last Name Format')
            alert('Invalid Last Name Format')
            return
        }
        else if (!value.middleName || !validateName(value.middleName)) {
            console.log('Invalid Middle Name Format')
            alert('Invalid Middle Name Format')
            return
        }
        else if (!value.displayName || !validateName(value.displayName)) {
            console.log('Invalid Display Name Format')
            alert('Invalid Display Name Format')
            return
        }
        else {
            return true
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        // if (checked) {
            if (doctorId) {
                try {
                    const valForm =  validateForm(value)
                    if (valForm) {
                        setIsDisabled(true)
                        await users.update({...value, salesId: salesData.id,seId: salesPersonId, rshId: salesData.rshId, adminId:salesData.adminId}, salesPersonId, doctorId).then(() => {
                            history.push("/thankyou");
                        }).catch((err) => {
                            console.error(err)
                            alert(err)
                        }).finally(()=> {
                            setIsDisabled(false)
                        })
                    }
                } catch (e) {
                    alert(e)
                }
            } else {
                try {
                    const valForm =  validateForm(value)
                    if (valForm) {
                        setIsDisabled(true)
                        await users.register({...value, salesId: salesData.id, seId: salesPersonId, rshId: salesData.rshId, adminId:salesData.adminId}).then((resp) => {
                            if(resp && resp.data && resp.data.code == 300){
                                alert("User already exists")
                            }
                            else{
                                history.push("/thankyou");   
                            }
                        }).catch((err) => {
                            alert(err)
                        }).finally(()=> {
                            setIsDisabled(false)
                        })
                    }
                } catch (e) {
                    alert(e)
                }
            }
        // } else {
        //     alert('You have to accept terms and conditions')
        // }
    }
    return (
        <div className={classes.registerContainer}>
            <Typography component="h2">Registration Form</Typography>
            {!isEditLoading && <form onSubmit={(e)=>handleSubmit(e)} className={classes.registerForm}>
                <div className={classes.registerContent}>
                    <TextInput
                        name={'email'}
                        label={'Email Address'}
                        required
                        defaultValue={defaultValue && defaultValue.email}
                        error={Boolean(error.email)}
                        helperText={error.email}
                        onChange={(e)=> {
                            if (!validateEmail(e.target.value)) {
                                setError({
                                    ...error,
                                    email: errorMessages.email
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    email: ''
                                })
                                handleChange(e)
                            }}}
                            onBlur={(e) => {
                                if (!validateEmail(value.email)) {
                                    setError({
                                        ...error,
                                        email: errorMessages.email
                                    })
                                } else {
                                    setError({
                                        ...error,
                                        email: ''
                                    })
                                }
                            }}
                    />
                    <TextInput
                        required
                        onChange={(e)=> {
                            if (!validateName(e.target.value)) {
                                setError({
                                    ...error,
                                    firstName: errorMessages.firstName
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    firstName: ''
                                })
                                handleChange(e)
                            }
                        }}
                        defaultValue={defaultValue && defaultValue.firstName}
                        name={'firstName'}
                        label={'First Name'}
                        error={Boolean(error.firstName)}
                        helperText={error.firstName}
                        onBlur={(e) => {
                            if (!validateName(value.firstName)) {
                                setError({
                                    ...error,
                                    firstName: errorMessages.firstName
                                })
                            } else {
                                setError({
                                    ...error,
                                    firstName: ''
                                })
                            }
                        }}
                    />
                    <TextInput
                       required
                        onChange={(e)=>{
                            if (!validateName(e.target.value)) {
                                setError({
                                    ...error,
                                    middleName: errorMessages.middleName
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    middleName: ''
                                })
                                handleChange(e)
                            }
                        }}
                        defaultValue={defaultValue && defaultValue.middleName}
                        name={'middleName'}
                        error={Boolean(error.middleName)}
                        helperText={error.middleName}
                        onBlur={() => {
                            if (!validateName(value.middleName)) {
                                setError({
                                    ...error,
                                    middleName: errorMessages.middleName
                                })
                            } else {
                                setError({
                                    ...error,
                                    middleName: ''
                                })
                            }
                        }}
                        label={'Middle Name (Enter NA if not Applicable)'}
                    />
                    <TextInput
                        required
                        defaultValue={defaultValue && defaultValue.lastName}
                        onChange={(e)=>{
                            if (!validateName(e.target.value)) {
                                setError({
                                    ...error,
                                    lastName: errorMessages.lastName
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    lastName: ''
                                })
                                handleChange(e)
                            }
                        }}
                        name={'lastName'}
                        label={'Last Name'}
                        helperText={error.lastName}
                        error={Boolean(error.lastName)}
                        onBlur={() => {
                            if (!validateName(value.lastName)) {
                                setError({
                                    ...error,
                                    lastName: errorMessages.lastName
                                })
                            } else {
                                setError({
                                    ...error,
                                    lastName: ''
                                })
                            }
                        }}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            if (!validateName(e.target.value)) {
                                setError({
                                    ...error,
                                    displayName: errorMessages.displayName
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    displayName: ''
                                })
                                handleChange(e)
                            }
                        }}
                        defaultValue={defaultValue && defaultValue.displayName}
                        name={'displayName'}
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Dr.
                              </InputAdornment>
                            ),
                        }}
                        label={'DISPLAY NAME ON PLATFORM'}
                        helperText={error.displayName}
                        error={Boolean(error.displayName)}
                        onBlur={() => {
                            if (!validateName(value.displayName)) {
                                setError({
                                    ...error,
                                    displayName: errorMessages.displayName
                                })
                            } else {
                                setError({
                                    ...error,
                                    displayName: ''
                                })
                            }
                        }}
                    />
                    <RadioInput
                        required
                        label={'Gender'}
                        name={'gender'}
                        defaultValue={defaultValue && defaultValue.gender || 'MALE'}
                        options={genderOptions}
                        onChange={(e)=> {
                            handleError('gender')
                            handleChange(e)
                        }}
                    />
                    <TextInput
                        name={'phone'}
                        label={'Mobile No'}
                        required
                        {...(defaultValue.phone ? {disabled: true} : {})}
                        defaultValue={defaultValue && defaultValue.phone}
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="end">
                                +91
                              </InputAdornment>
                            ),
                        }}
                        helperText={error.phone}
                        error={Boolean(error.phone)}
                        onChange={(e)=> {
                            if (!validateMobile(e.target.value)) {
                                setError({
                                    ...error,
                                    phone: errorMessages.phone
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    phone: ''
                                })
                                handleChange(e)
                            }
                        }}
                        onBlur={()=> {
                            if (!validateMobile(value.phone)) {
                                setError({
                                    ...error,
                                    phone: errorMessages.phone
                                })
                            } else {
                                setError({
                                    ...error,
                                    phone: ''
                                })
                            }
                        }}
                    />
                    <TextInput
                        name={'alternatePhone'}
                        label={'Alternate Mobile No'}
                       // required
                        defaultValue={defaultValue && defaultValue.alternatePhone}
                        helperText={error.alternatePhone}
                        error={Boolean(error.alternatePhone)}
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="end">
                                +91
                              </InputAdornment>
                            ),
                        }}
                        onChange={(e)=> {
                            if (!validateMobile(e.target.value)) {
                                setError({
                                    ...error,
                                    alternatePhone: errorMessages.phone
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    alternatePhone: ''
                                })
                                handleChange(e)
                            }
                        }}
                        onBlur={()=> {
                            if (!validateMobile(value.alternatePhone)) {
                                setError({
                                    ...error,
                                    alternatePhone: errorMessages.phone
                                })
                            } else {
                                setError({
                                    ...error,
                                    alternatePhone: ''
                                })
                            }
                        }}
                    />
                    <TextInput

                    name={'alternatePhone'}
                    label={'Alternate Mobile No'}
                   // required
                    defaultValue={defaultValue && defaultValue.alternatePhone}
                    helperText={error.alternatePhone}
                    error={Boolean(error.alternatePhone)}
                    InputProps={{
                        startAdornment: (
                          <InputAdornment position="end">
                            +91
                          </InputAdornment>
                        ),
                    }}
                        onChange={(e)=>{
                            handleError('alternatePhoneTwo')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.alternatePhoneTwo}
                        name={'alternatePhoneTwo'}
                        label={'Alternate Phone No 2'}
                        onChange={(e)=> {
                            if (!validateMobile(e.target.value)) {
                                setError({
                                    ...error,
                                    alternatePhoneTwo: errorMessages.phone
                                })
                                handleChange(e)
                            } else {
                                setError({
                                    ...error,
                                    alternatePhoneTwo: ''
                                })
                                handleChange(e)
                            }
                        }}
                        onBlur={()=> {
                            if (!validateMobile(value.alternatePhone)) {
                                setError({
                                    ...error,
                                    alternatePhoneTwo: errorMessages.phone
                                })
                            } else {
                                setError({
                                    ...error,
                                    alternatePhoneTwo: ''
                                })
                            }
                        }}
                    />
                    <CheckBoxInput
                        required
                        label={'Languages'}
                        name={'languages'}
                        options={languageOptions}
                        defaultValue={defaultValue && defaultValue.languages}
                        onChange={(e)=> {
                            handleError('languages')
                            handleChange(e)
                        }}
                    />
                    <FileInput
                        required
                        onChange={(e)=> {
                            handleError('profilepic')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.profilepic}
                        name='profilepic'
                      //  label={'Profile picture *'}
                        label={
                            <>
                                Profile picture{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        hintText={'Please upload a recent professional passport-size photograph for your profile (jpeg format) *'}

                        onBlur={() => handleError('profilepic')}
                    />
                    <TextInput
                       name={'panNumber'}
                       label={'PAN Card Number'}
                     
                       required
                       defaultValue={defaultValue && defaultValue.panNumber}
                       helperText={error.panNumber}
                       error={Boolean(error.panNumber)}
                       onChange={(e)=> {
                           if (!validatePan(e.target.value)) {
                               setError({
                                   ...error,
                                   panNumber: errorMessages.panNumber
                               })
                               handleChange(e)
                           } else {
                               setError({
                                   ...error,
                                   panNumber: ''
                               })
                               handleChange(e)
                           }
                       }}
                       onBlur={()=> {
                           if (!validatePan(value.panNumber)) {
                               setError({
                                   ...error,
                                   panNumber: errorMessages.panNumber
                               })
                           } else {
                               setError({
                                   ...error,
                                   panNumber: ''
                               })
                           }
                       }} 
                    />
                    <FileInput
                        required
                        onChange={(e)=> {
                            handleError('pancard')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.pancard}
                        name='pancard'
                   //     label={'Upload PAN Card *'}
                        label={
                            <>
                                Upload PAN Card{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        hintText={'Please upload a scanned copy of your PAN Card for identification proof *'}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('clinic')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.clinic}
                        name={'clinic'}
                        label={'Name of the Clinic / Hospital'}
                        helperText={error.clinic}
                        error={Boolean(error.clinic)}
                        onBlur={() => handleError('clinic')}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('locationName')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.locationName}
                        name={'locationName'}
                        label={'Clinic/Hospital Street Name'}
                        helperText={error.locationName}
                        error={Boolean(error.locationName)}
                        onBlur={() => handleError('locationName')}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('address')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.address}
                        name={'address'}
                        label={'Clinic/Hospital Address'}
                        helperText={error.address}
                        error={Boolean(error.address)}
                        onBlur={() => handleError('address')}
                    />
                    <Pincode
                       type="number"
                       name={'pincode'}
                       required
                       defaultValue={defaultValue && defaultValue.pincode}
                       onComplete={(e)=>{
                           handleError('pincode')
                           handleChange(e)
                        }}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('city')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.city}
                        name={'city'}
                        label={'Clinic/Hospital City'}
                        helperText={error.city}
                        error={Boolean(error.city)}
                        onBlur={() => handleError('city')}
                    />
                    <AutoComplete
                    required
                    name={'state'}
                    defaultValue={defaultValue && defaultValue.state}
                    options={stateOptions}
                    label={'State'}
                    onChange={(e)=>{
                        handleError('state')
                        handleChange(e)
                    }}
                    ></AutoComplete>
                    <SelectInput
                        name={'country'}
                        label={'Country'}
                        required
                        disabled
                        defaultValue={defaultValue && defaultValue.country}
                        defaultValue={'India'}
                        helperText={error.country}
                        options={countryOptions}
                        onChange={(e)=>{
                            handleChange(e)
                        }}
                    />
                    <RadioInput
                        required
                        label={'Address Proof'}
                        name={'addressProof'}
                        defaultValue={defaultValue && defaultValue.addressProof}
                        options={addressProofOptions}
                        onChange={(e)=>{
                            handleError('addressProof')
                            handleChange(e)
                        }}
                    />
                    <FileInput
                        required
                        onChange={(e)=>{
                            handleError('addressProofFile')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.addressProofFile}
                        name='addressProofFile'
                      //  label={'Upload Front Side *'}
                        label={
                            <>
                                Upload Front Side{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        hintText={'Please upload Front side of Aadhaar as address proof *'}
                    />

                    <FileInput
                        required
                        onChange={(e)=>{
                            handleError('adhar_backside')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.addressProofFile}
                        name='adhar_backside'
                     //   label={'Upload Back side *'}
                        label={
                            <>
                                Upload Back Side{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        hintText={'Please upload Back side of Aadhaar as address proof *'}
                    />

                   
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('education')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.education}
                        name={'education'}
                        helperText={error.education}
                        label={'Education (separated by commas) Eg, MBBS, MD, DM'}
                        error={Boolean(error.education)}
                        onBlur={() => handleError('education')}
                    />
{/* 
<TextInput
                       // type="number"
                        name={'college_name'}
                        label={'College Name'}
                        defaultValue={defaultValue && defaultValue.college_name}
                        onChange={(e)=>{
                         //   handleError('college_name')
                            handleChange(e)
                        }}
                    /> */}


                    {/* <TextInput
                        required
                        type={"text"}
                        onChange={(e)=>{
                            handleError('graduation_year')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.graduation_year}
                        name={'graduation_year'}
                        helperText={error.experience}
                        label={'Graduation Year'}
                        error={Boolean(error.experience)}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                
                              </InputAdornment>
                            ),
                        }}
                        onBlur={() => handleError('graduation_year')}
                    /> */}

                    {/* <FileInput
                        required
                        onChange={(e)=>{
                       //     handleError('education_proof')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.education_proof}
                        name='education_proof'
                        label={'Upload Education Proof'}
                       // hintText={'Please upload any one appropriate document as per the selected education proof'}
                    />   */}
<FileInput
    required
    onChange={(e) => {
        //   handleError('btech_education_proof')
        handleChange(e)
    }}
    defaultValue={defaultValue && defaultValue.btech_education_proof}
    name='btech_education_proof'
    label={
        <>
            Upload Undergraduate (MBBS/BDS/BPT) Certificate{' '}
            <span style={{ color: 'red' }}>*</span>
        </>
    }
    hintText={
        <>
            Please upload any one appropriate document as per the selected education proof{' '}
            <span style={{ color: 'red' }}>*</span>
        </>
    }
/>



                    <FileInputV2
                     //   required
                        onChange={(e)=>{
                          //  handleError('phd_education_proof')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.phd_education_proof}
                        name='phd_education_proof'
                        label={'Post Graduate (PG) Certificate - (if any)'}
                        hintText={'Please upload any one appropriate document as per the selected education proof'}
                    />

                    <FileInputV2
                        
                        onChange={(e)=>{
                          //  handleError('diploma_education_proof')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.diploma_education_proof}
                        name='diploma_education_proof'
                        label={'Diploma Certificate - (if any)'}
                        hintText={'Please upload any one appropriate document as per the selected education proof'}
                    />

                    
                    <FileInputV2
                        
                        onChange={(e)=>{
                          //  handleError('dnb_certificate')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.dnb_certificate}
                        name='dnb_certificate'
                        label={'DNB (Diplomate of National Board) Certificate - (if any)'}
                        hintText={'Please upload any one appropriate document as per the selected education proof'}
                    
                    />

                    
                    <FileInputV2   
                        onChange={(e)=>{
                         //   handleError('speciality_certificate')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.speciality_certificate}
                        name='speciality_certificate'
                        label={'Super specialty certificate - (if any)'}
                        hintText={'Please upload any one appropriate document as per the selected education proof'}
                    />

                    <FileInputV2
                          onChange={(e)=>{
                           // handleError('fellowship_certificate')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.fellowship_certificate}
                            name='fellowship_certificate'
                        label={'Fellowship certificate (if any)'}
                        hintText={'Please upload any one appropriate document as per the selected education proof'}
                    />


                    <TextInput
                        required
                        type={"number"}
                        onChange={(e)=>{
                            handleError('experience')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.experience}
                        name={'experience'}
                        helperText={error.experience}
                        label={'Years of Experience'}
                        error={Boolean(error.experience)}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                Years
                              </InputAdornment>
                            ),
                        }}
                        onBlur={() => handleError('experience')}
                    />
                    <SelectInput
                        name={'specialty'}
                        label={'Speciality'}
                        required
                        helperText={error.specialty}
                        defaultValue={defaultValue && defaultValue.specialty}
                        options={sortByAlphabetical(specialtyOptions)}
                        onChange={(e)=>{
                            handleError('specialty')
                            handleChange(e)
                        }}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('mciNumber')
                            handleChange(e)
                        }}
                        name={'mciNumber'}
                        label={'SMC/ DMC/RCI/ IDA/ IAP /MCI Registration No.'}
                        defaultValue={defaultValue && defaultValue.mciNumber}
                        helperText={error.mciNumber}
                        error={Boolean(error.mciNumber)}
                        onBlur={() => handleError('mciNumber')}
                    />
                    <div style={{color: 'red'}}>
                        {"Disclaimer :- Please enter your valid SMC/ Dental Medical Council  Registration number. In case of invalid number, your profile will be rejected."}
                    </div>
                    
    <FileInput
    required
    helperText={error.registrationCertificate}
    defaultValue={defaultValue && defaultValue.registrationCertificate}
    onChange={(e) => {
        handleError('registrationCertificate')
        handleChange(e)
    }}
    name='registrationCertificate'
    label={
        <>
            Upload SMC/ DMC/RCI/IDA/IAP Registration Certificate{' '}
            <span style={{ color: 'red' }}>*</span>
        </>
    }
/>
<div style={{ color: 'red' }}>
    Disclaimer: Please Upload SMC/DMC/RCI/IDA/IAP Registration certificate. In case of non-compliance, your profile will be rejected.
</div>

<TextInput
                        onChange={(e)=>{
                            handleError('certifications')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.certifications}
                        name={'certifications'}
                        label={'Awards/Certifications (if any)'}
                    />
 
                    <RadioInput
                        required
                        label={'Type of Consult'}
                        name={'consultType'}
                        options={consultTypeOptions}
                        defaultValue={defaultValue && defaultValue.consultType || 'BOTH'}
                        onChange={(e)=> {
                            handleChange(e)
                            handleError('consultType')
                            setConsultType(e.target.value)
                        }}
                    />
                      <CheckBoxInput
                        required
                        label={'Weekday'}
                        name={'weekdays'}
                        options={weekOptions}
                        defaultValue={defaultValue && defaultValue.weekdays}
                        onChange={(e)=>{
                            handleError('weekdays')
                            handleChange(e)
                        }}
                    />
                   
                    <AvailableSlots name={'slots'}  
                    defaultValue={defaultValue && defaultValue.slots}
                    onChange={(e)=>{
                            handleError('slots')
                            handleChange(e)
                        }} />
{/* 
                    <AvailableSlotsPhysical name={'slots_phy'}  
                    defaultValue={defaultValue && defaultValue.slots}
                    onChange={(e)=>{
                            handleError('slots')
                            handleChange(e)
                        }} /> */}

                    {[consultTypeOptions[0].value, consultTypeOptions[2].value].includes(consultType) && <TextInput
                        required
                        type={'number'}
                        onChange={(e)=>{
                            handleError('onlinefees')
                            handleChange(e)
                        }}
                        onKeyPress={(e)=> {
                            if(e.key==='.' || e.key === 'e'){
                                e.preventDefault();
                            }
                        }}
                        name={'onlinefees'}
                        defaultValue={defaultValue && defaultValue.onlinefees}
                        label={'Online Consultation fees'}
                        helperText={error.onlinefees}
                        error={Boolean(error.onlinefees)}
                        onBlur={() => handleError('onlinefees')}
                    />}
                    {[ consultTypeOptions[1].value, consultTypeOptions[2].value].includes(consultType) && <TextInput
                        required
                        type={'number'}
                        onChange={(e)=>{
                            handleError('physicalfees')
                            handleChange(e)
                        }}
                        
                        onKeyPress={(e)=> {
                            if(e.key==='.' || e.key === 'e'){
                                e.preventDefault();
                            }
                        }}
                        defaultValue={defaultValue && defaultValue.physicalfees}
                        helperText={error.physicalfees}
                        name={'physicalfees'}
                        label={'Physical Consultation fees'}
                        error={Boolean(error.physicalfees)}
                        onBlur={() => handleError('physicalfees')}

                    />}
          
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('nameAsPerBank')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.nameAsPerBank}
                        helperText={error.nameAsPerBank}
                        name={'nameAsPerBank'}
                        label={'Name as per Bank records'}
                        error={Boolean(error.nameAsPerBank)}
                        onBlur={() => handleError('nameAsPerBank')}
                    />

                    <FileInput
                        required
                        onChange={(e)=>{
                          //  handleError('phd_education_proof')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.cancel_check}
                        name='cancel_check'
                      //  label={'Upload Cancelled cheque'}
                        label={
                            <>
                                Upload Cancelled Cheque{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        hintText={'Please upload Cancelled Cheque as Bank proof *'}
                    />

                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('bankBranch')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.bankBranch}
                        helperText={error.bankBranch}
                        name={'bankBranch'}
                        label={'Bank Branch Name'}
                        error={Boolean(error.bankBranch)}
                        onBlur={() => handleError('bankBranch')}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('accountNumber')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.accountNumber}
                        name={'accountNumber'}
                        label={'Bank Account Number'}
                        helperText={error.accountNumber}
                        error={Boolean(error.accountNumber)}
                        onBlur={() => handleError('accountNumber')}
                    />
                    <TextInput
                        required
                        onChange={(e)=>{
                            handleError('ifscCode')
                            handleChange(e)
                        }}
                        name={'ifscCode'}
                        defaultValue={defaultValue && defaultValue.ifscCode}
                        label={'IFSC Code'}
                        helperText={error.ifscCode}
                        error={Boolean(error.ifscCode)}
                        onBlur={() => handleError('ifscCode')}
                    />
                    <TextInput
                           onChange={(e)=>{
                            handleError('secretaryName')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.secretaryName}
                        name={'secretaryName'}
                        label={`Secretary's Name (if available)`}
                    />
                    <TextInput
                        type="number"
                        name={'secretaryNumber'}
                        label={'Secretary Number'}
                        defaultValue={defaultValue && defaultValue.secretaryNumber}
                        onChange={(e)=>{
                            handleError('secretaryNumber')
                            handleChange(e)
                        }}
                    />

                       
                </div>
             
               

                    <TextInput
                           onChange={(e)=>{
                         //   handleError('membership')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.membership}
                        name={'membership'}
                        label={`Any Professional Membership`}
                    />

                    <TextInput
                           onChange={(e)=>{
                            handleError('conditions_procedure')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.conditions_procedure}
                        name={'conditions_procedure'}
                        label={`Conditions & Procedures Treated`}
                    />

                        <TextInput
                           onChange={(e)=>{
                            handleError('services_offered')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.services_offered}
                        name={'services_offered'}
                        label={`Services Offered`}
                        />

                    {/* <FileInput
                        
                        onChange={(e)=>{
                            handleError('profile_picture')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.profile_picture}
                        name='profile_picture'
                        label={'Upload Profile Picture'}
                        hintText={'Please upload Professional Profile Picture'}
                    /> */}

                    <TextInput
                           onChange={(e)=>{
                            handleError('publication_link')
                            handleChange(e)
                        }}
                        defaultValue={defaultValue && defaultValue.publication_link}
                        name={'publication_link'}
                        label={`Research & Publication (Link) Add Commas Seperated Links, if you are Adding Multiple Links`}
                    />

                <button disabled={isDisabled} type='submit' className={classes.submitBtn}>Submit</button>
            </form>}
        </div>
    )
}


export default Register;